import { stringify } from "query-string"
import { farasod } from "./api"

const endpoint = "/customer-print-template"

export const getCustomerPrintTemplate = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const createCustomerPrintTemplate = async (data) => {
  const response = await farasod.post(endpoint, data)

  return response.data
}

export const editCustomerPrintTemplate = async (data) => {
  const response = await farasod.patch(endpoint, data)

  return response.data
}